import { getGameShareUrl } from './shareGameLink'
import { encodeCharacterIdQueryValue } from './characterSharePayload'
import { applyRefIdSearchParam } from './refIdShareParam'

export function buildCharacterContinueUrl(
    refDocumentId?: string | null,
): string {
    const url = new URL(getGameShareUrl())
    const token = encodeCharacterIdQueryValue().trim()
    if (token) {
        url.searchParams.set('characterID', token)
    }
    applyRefIdSearchParam(url, refDocumentId)
    return url.toString()
}
